module.exports = __webpack_public_path__ + "static/door-87d469513d7b0726ca995b358325455d.webm";